export default __webpack_public_path__ + "static/media/fala główna strona.55ec080d.png";